import React from "react";
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg'

const SVGIcon = ({ color, size, icon }) => (
	<ReactSVG
		beforeInjection={(svg) => {
			svg.setAttribute('style', 'width: ' + size)
			svg.setAttribute("fill", color)
		}}
		src={icon}
	/>
);

SVGIcon.propTypes = {
	color: PropTypes.string,
	size: PropTypes.string.isRequired,
	icon: PropTypes.any.isRequired
};

export default SVGIcon;